import axios from "axios";

export async function agentRegister(jsonData, token) {
	let serial = { aSerial: null, error: null };

	let uri = "https://dev2.silubi.io/prov-wrt/provapi/enactor/session";
	try {
		const resp = await axios.post(
			uri,
			{},
			{
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "text/csv",
				},
			}
		);

		if (resp.status === 200) {
			console.log("Session opened :: " + resp.data.uuid);
			console.log("Posting agent data :: " + JSON.stringify(jsonData, null, 2));
			const resp2 = await axios.post(`${uri}/${resp.data.uuid}`, JSON.stringify(jsonData), {
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/vnd.wrt.prov-enact+json",
					Accept: "text/csv",
				},
			});

			if (resp2.status === 200) {
				console.log("Received serial of the agent :: " + resp2.data.split(",")[2]);
				serial.aSerial = resp2.data.split(",")[2];
			} else throw new Error(resp2);
		} else throw new Error(resp);
		//Close session
		console.log("Closing session :: " + resp.data.uuid);
		const deleteingSession = await axios.delete(
			`${uri}/${resp.data.uuid}`,

			{
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
			}
		);

		if (deleteingSession.status === 400) throw new Error(deleteingSession);
		console.log("Session :: " + resp.data.uuid + " closed. " + JSON.stringify(deleteingSession.data, null, 2));
	} catch (err) {
		serial.error = err.message;
	}
	return serial;
}
